module.exports = __webpack_public_path__ + "img/balance.8cff31b6.svg";